module.exports = __webpack_public_path__ + "img/production5.2de3e961.png";